module.exports = __webpack_public_path__ + "assets/img/success.3ebe1434.png";